import { render, staticRenderFns } from "./InstructionsDialogBox.vue?vue&type=template&id=3d46a4c0&scoped=true"
import script from "./InstructionsDialogBox.vue?vue&type=script&lang=ts"
export * from "./InstructionsDialogBox.vue?vue&type=script&lang=ts"
import style0 from "./InstructionsDialogBox.vue?vue&type=style&index=0&id=3d46a4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46a4c0",
  null
  
)

export default component.exports